import React from "react";

const AgencySetup = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
      >
        <g clipPath="url(#clip0_631_1865)">
          <path
            d="M1.65 0C0.739062 0 0 0.755859 0 1.6875V16.3125C0 17.2441 0.739062 18 1.65 18H4.95V15.1875C4.95 14.2559 5.68906 13.5 6.6 13.5C7.51094 13.5 8.25 14.2559 8.25 15.1875V18H11.3403C11.1237 17.6414 11 17.2195 11 16.766C11 15.1172 11.8869 13.6793 13.2 12.927V9.55547V1.6875C13.2 0.755859 12.4609 0 11.55 0H1.65ZM2.2 8.4375C2.2 8.12813 2.4475 7.875 2.75 7.875H3.85C4.1525 7.875 4.4 8.12813 4.4 8.4375V9.5625C4.4 9.87187 4.1525 10.125 3.85 10.125H2.75C2.4475 10.125 2.2 9.87187 2.2 9.5625V8.4375ZM6.05 7.875H7.15C7.4525 7.875 7.7 8.12813 7.7 8.4375V9.5625C7.7 9.87187 7.4525 10.125 7.15 10.125H6.05C5.7475 10.125 5.5 9.87187 5.5 9.5625V8.4375C5.5 8.12813 5.7475 7.875 6.05 7.875ZM8.8 8.4375C8.8 8.12813 9.0475 7.875 9.35 7.875H10.45C10.7525 7.875 11 8.12813 11 8.4375V9.5625C11 9.87187 10.7525 10.125 10.45 10.125H9.35C9.0475 10.125 8.8 9.87187 8.8 9.5625V8.4375ZM2.75 3.375H3.85C4.1525 3.375 4.4 3.62812 4.4 3.9375V5.0625C4.4 5.37187 4.1525 5.625 3.85 5.625H2.75C2.4475 5.625 2.2 5.37187 2.2 5.0625V3.9375C2.2 3.62812 2.4475 3.375 2.75 3.375ZM5.5 3.9375C5.5 3.62812 5.7475 3.375 6.05 3.375H7.15C7.4525 3.375 7.7 3.62812 7.7 3.9375V5.0625C7.7 5.37187 7.4525 5.625 7.15 5.625H6.05C5.7475 5.625 5.5 5.37187 5.5 5.0625V3.9375ZM9.35 3.375H10.45C10.7525 3.375 11 3.62812 11 3.9375V5.0625C11 5.37187 10.7525 5.625 10.45 5.625H9.35C9.0475 5.625 8.8 5.37187 8.8 5.0625V3.9375C8.8 3.62812 9.0475 3.375 9.35 3.375ZM19.8 9.5625C19.8 8.81658 19.5103 8.10121 18.9945 7.57376C18.4788 7.04632 17.7793 6.75 17.05 6.75C16.3207 6.75 15.6212 7.04632 15.1055 7.57376C14.5897 8.10121 14.3 8.81658 14.3 9.5625C14.3 10.3084 14.5897 11.0238 15.1055 11.5512C15.6212 12.0787 16.3207 12.375 17.05 12.375C17.7793 12.375 18.4788 12.0787 18.9945 11.5512C19.5103 11.0238 19.8 10.3084 19.8 9.5625ZM12.1 16.773C12.1 17.4516 12.6363 18 13.2997 18H20.8003C21.4637 18 22 17.4516 22 16.773C22 14.966 20.5666 13.5 18.7997 13.5H15.3003C13.5334 13.5 12.1 14.966 12.1 16.773Z"
            fill="#0075AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_631_1865">
            <rect
              width="22"
              height="18"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default AgencySetup;
